import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  campaignList: [],
  status: 'idle',
  error: null,
};

const campaignSlice = createSlice({
  name: 'campaignList',
  initialState,
  reducers: {
    setCampaignList: (state, action) => {
      state.campaignList = action.payload;
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setCampaignList, setError, setLoading } = campaignSlice.actions;
export default campaignSlice.reducer;
